/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaginationInfo
 */
export interface PaginationInfo {
    /**
     * 
     * @type {boolean}
     * @memberof PaginationInfo
     */
    enablePrevious: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationInfo
     */
    enableNext: boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationInfo
     */
    lowerRange: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationInfo
     */
    upperRange: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationInfo
     */
    total: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof PaginationInfo
     */
    availableOffsets: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof PaginationInfo
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationInfo
     */
    offset: number;
}

/**
 * Check if a given object implements the PaginationInfo interface.
 */
export function instanceOfPaginationInfo(value: object): value is PaginationInfo {
    if (!('enablePrevious' in value) || value['enablePrevious'] === undefined) return false;
    if (!('enableNext' in value) || value['enableNext'] === undefined) return false;
    if (!('lowerRange' in value) || value['lowerRange'] === undefined) return false;
    if (!('upperRange' in value) || value['upperRange'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('availableOffsets' in value) || value['availableOffsets'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('offset' in value) || value['offset'] === undefined) return false;
    return true;
}

export function PaginationInfoFromJSON(json: any): PaginationInfo {
    return PaginationInfoFromJSONTyped(json, false);
}

export function PaginationInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginationInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'enablePrevious': json['enablePrevious'],
        'enableNext': json['enableNext'],
        'lowerRange': json['lowerRange'],
        'upperRange': json['upperRange'],
        'total': json['total'],
        'availableOffsets': json['availableOffsets'],
        'limit': json['limit'],
        'offset': json['offset'],
    };
}

export function PaginationInfoToJSON(json: any): PaginationInfo {
    return PaginationInfoToJSONTyped(json, false);
}

export function PaginationInfoToJSONTyped(value?: PaginationInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enablePrevious': value['enablePrevious'],
        'enableNext': value['enableNext'],
        'lowerRange': value['lowerRange'],
        'upperRange': value['upperRange'],
        'total': value['total'],
        'availableOffsets': value['availableOffsets'],
        'limit': value['limit'],
        'offset': value['offset'],
    };
}

